module.exports = __webpack_public_path__ + "static/media/transfer_a_person_important.788f4105.svg";